<div
  class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
  style="
    background-image: url('assets/images/dashboard/login.avif');
    height: 100vh;
  "
  id="mainDiv"
>
  <div
    class="auth-block center-div"
    style="
      text-align: center;
      background-color: white;
      border-radius: 10px;
      padding: 2%;
      width: 400px;
    "
    *ngIf="showLogin"
  >
    <div style="float: right"></div>
    <div style="text-align: center; padding: 2% 0">
      <img
        alt=""
        ng-src="assets/images/dashboard/unified-ai-logo-blue.avif"
        height="50"
        width="201"
        src="assets/images/dashboard/unified-ai-logo-blue.avif"
      />
    </div>
    <div class="auth-block-body">
      <form
        name="loginForm"
        (ngSubmit)="loginForm.form.valid && sign_in(user)"
        #loginForm="ngForm"
        novalidate
      >
        <div
          class="col-lg-12 col-md-12 col-sm-12 col-xs-12 login-input"
          style="padding: 5% 5%; display: grid"
        >
          <div class="form-group">
            <div
              class="col-lg-12 col-md-12 col-sm-12 col-xs-12 login-input"
              [class.error-textbox]="error.status === true"
            >
              <label
                for="loginUserName"
                style="
                  color: #333333;
                  text-align: start;
                  width: inherit;
                  margin-bottom: 5px;
                  font-weight: 500;
                "
                >{{ 'login.username' | translate }}</label
              >
              <div>
                <div class="input-group-prepend" id="loginusernameicon">
                  <span class=""
                    ><em
                      class="fas fa-user"
                      style="color: black; font-size: medium"
                    ></em
                  ></span>
                </div>
                <input
                  id="loginUserName"
                  type="text"
                  class="form-control"
                  name="user"
                  [(ngModel)]="user.username"
                  style="
                    padding-left: 10%;
                    border-radius: 5px;
                    color: #333333 !important;
                  "
                  i18n-placeholder="@@placeHolderUserName"
                  placeholder="{{ 'login.username' | translate }}"
                  #userName="ngModel"
                  autocomplete="username"
                  required
                />
              </div>
              <span
                class="loginError"
                i18n="@@usernameRequired"
                *ngIf="
                  (loginForm.submitted && userName.invalid) ||
                  (userName.errors && (userName.dirty || userName.touched))
                "
              >
                {{ 'login.username_required' | translate }}
              </span>
            </div>
          </div>

          <div class="form-group" style="margin-bottom: 0">
            <div
              class="col-lg-12 col-md-12 col-sm-12 col-xs-12 login-input"
              [class.error-textbox]="error.status === true"
            >
              <label
                for="loginPassword"
                style="
                  color: #333333;
                  text-align: start;
                  width: inherit;
                  margin-bottom: 5px;
                  font-weight: 500;
                "
                >{{ 'login.password' | translate }}</label
              >
              <div>
                <div class="input-group-prepend" id="loginpasswordIcon">
                  <span class=""
                    ><em
                      class="fas fa-lock"
                      style="color: black; font-size: medium"
                    ></em
                  ></span>
                </div>
                <input
                  id="loginPassword"
                  type="password"
                  class="form-control"
                  name="password"
                  [(ngModel)]="user.password"
                  style="
                    padding-left: 10%;
                    border-radius: 5px;
                    color: #333333 !important;
                  "
                  i18n-placeholder="@@placeHolderPassword"
                  placeholder="{{ 'login.password' | translate }}"
                  #password="ngModel"
                  autocomplete="current-password"
                  required
                />
              </div>
              <span
                class="loginError"
                i18n="@@passwordRequired"
                *ngIf="
                  (loginForm.submitted && password.invalid) ||
                  (password.errors && (password.dirty || password.touched))
                "
              >
                {{ 'login.password_required' | translate }}
              </span>
            </div>
          </div>
          <div class="form-group" style="margin-top: 12px">
            <div
              style="width: 151px; float: right; margin-top: 2px"
              id="loginForgotPasswordLabel"
              id="loginsignup"
            >
              <label
                for="loginforgotpassword"
                class="col-lg-12 col-md-12 col-sm-12 col-xs-12 login-input"
                (click)="showTemplate(forgotPassword)"
                (keydown)="showTemplate(forgotPassword)"
                style="
                  cursor: pointer;
                  font-weight: 500;
                  margin-bottom: 0;
                  margin-top: -2%;
                  color: #333333;
                "
                name="forgetpassword"
                id="forgetpassword"
                >{{ 'login.forgot_password' | translate }}</label
              >
            </div>
          </div>
          <div
            class="form-group"
            style="margin-bottom: 0"
            id="loginforgotpassword"
          >
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 login-input">
              <button
                id="loginSubmit"
                class="btn-default btn-auth"
                type="submit"
                style="
                  background-color: #386ba7;
                  border-radius: 5px;
                  box-shadow:
                    inset 0 1px 14px 0 rgba(30, 135, 240, 0.2),
                    0 0 14px 0 rgba(30, 135, 240, 0.3);
                "
              >
                {{ 'login.title' | translate }}
              </button>
            </div>
          </div>
          	<!-- <div *ngIf="ssoEnabled" class="form-group">
            <div
              class="col-lg-12 col-md-12 col-sm-12 col-xs-12 login-input"
              style="text-align: left"
            >
              <label
                for="login.sign_in_using"
                style="
                  cursor: pointer;
                  font-weight: 500;
                  margin-bottom: 0;
                  margin-top: 5%;
                  color: #333333;
                  text-align: left;
                "
                name="forgetpassword"
                >{{ 'login.sign_in_using' | translate }}
              </label>
            </div>
            <div
              class="col-lg-12 col-md-12 col-sm-12 col-xs-12 login-input"
              style="padding-top: 16px"
              id="login.sign_in_using"
            >
              
              <div
                style="float: left; cursor: pointer"
                id="googleSignin"
                class="googlSignin"
                (click)="loginUsingGoogle()"
                (keydown)="loginUsingGoogle()"
              >
                <em class="fa-brands fa-google" style="font-size: 22px"></em>
              </div>
              <span
                class="loginError"
                i18n="@@error"
                *ngIf="googleError"
                style="padding: 5px"
              >
                {{ googleError }}
              </span>
              
              <div style="float: left; padding-left: 20px">
                <div
                  class="app-linkedin-login btn btn-linkedin"
                  (click)="loginUsingLinkedIn()"
                  (keydown)="loginUsingLinkedIn()"
                >
                  <em class="fa fa-linkedin" style="font-size: 22px"></em>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group"
            style="margin-top: 10px"
          >
            <div
              for="loginsignup"
              style="font-weight: 500; color: #333333"
              name="signup"
              id="signup"
            >
              Don't have an account? &nbsp;<a
                (click)="showTemplateSignUp()"
                (keydown)="showTemplateSignUp()"
                style="color: #0034ac !important; cursor: pointer"
                >{{ 'login.signUp' | translate }}</a
              >
            </div>
          </div> -->
        </div>
      </form>
    </div>

    <ng-template #forgotPassword>
      <div class="">
        <div
          class="col-md-12"
          class="modal-content"
          style="border-radius: 6px 6px 0 0 !important"
        >
          <div class="modal-header headerModal" style="text-align: center">
            <button type="button" class="close" (click)="onCancel()">
              &times;
            </button>
            <h4 class="modal-title">
              {{ 'login.forgot_password' | translate }}
            </h4>
          </div>

          <div style="padding: 2%">
            <div style="text-align: center; padding: 1% 2% 3% 2%">
              <span style="font-size: 18px">{{
                'login.reset_message' | translate
              }}</span>
            </div>
            <div class="auth-block-body" style="height: 85px; width: auto">
              <div class="col-xs-9 login-input" style="padding: 2%">
                <div class="form-group">
                  <div class="col-xs-12 login-input">
                    <input
                      id="forgotPasswordEmail"
                      [attr.aria-label]="'common.email' | translate"
                      type="text"
                      class="form-control"
                      name="email"
                      [(ngModel)]="email"
                      placeholder="{{ 'common.email' | translate }}"
                      style="border-radius: 5px; color: #333333 !important"
                      autocomplete="off"
                      required
                    />
                    <span
                      id="email_requires"
                      *ngIf="
                        forgotPasswordSubmitted &&
                        (email == '' || email == undefined || email == null)
                      "
                    >
                      {{ 'login.email_required' | translate }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-3 login-input submit" style="padding: 2%">
                <div
                  class="login-submit"
                  style="
                    padding: 0;
                    margin: 0;
                    height: auto;
                    background-color: #386ba7;
                    border-radius: 5px;
                  "
                >
                  <button
                    id="submitForgotPassword"
                    class="btn-default btn-auth"
                    type="button"
                    (click)="submitForgotPassword()"
                  >
                    {{ 'common.submit' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
